import TopLogout from "../components/TopLogout";
import React, { useState } from "react";
import BottomNav from "../components/BottomNav";

export default function Home() {
  const [hover, setHover] = useState(false);

  const features = [
    {
      title: "Real-time Monitoring",
      desc: "Live data from TDS, pH, NPK, Temperature, Humidity, and Light Sensors.",
    },
    {
      title: "Smart Automation",
      desc: "Motors, Lights, and Humidifier automatically controlled by system logic.",
    },
    {
      title: "Cloud Connected",
      desc: "Data stored and managed using Firebase for high reliability.",
    },
    {
      title: "History & Reports",
      desc: "View and download past data in PDF format.",
    },
    {
      title: "User Management",
      desc: "Admins can add users and change passwords.",
    },
  ];

  const loopFeatures = [...features, ...features];

  return (
    <div style={styles.bg}>
      {/* ⭐ COMPANY LOGO TOP-LEFT */}
      <img src="/com_logo.png" alt="Company Logo" style={styles.companyLogo} />

      <div style={styles.overlay}>
        <TopLogout />
        <h1 style={styles.title}>Smart Agriculture System</h1>

        <p style={styles.subtitle}>
          Automated system for monitoring and controlling plant health using
          advanced sensors and real-time analytics.
        </p>

        {/* ✅ DOWNLOAD APK BUTTON */}
        <a
          href="/apk/smart-agri.apk"
          download
          style={{
            ...styles.downloadBtn,
            ...(hover ? styles.downloadBtnHover : {}),
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          Download Smart-Agri Android App
        </a>

        <div style={styles.sliderWrapper}>
          <div style={styles.slider}>
            {loopFeatures.map((item, index) => (
              <div key={index} style={styles.card}>
                <h3 style={styles.cardTitle}>{item.title}</h3>
                <p style={styles.cardDesc}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}

const styles = {
  bg: {
    backgroundImage: "url('/bg2.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    width: "100%",
    position: "relative",
  },

  companyLogo: {
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "140px",
    zIndex: 1000,
  },

  overlay: {
    background: "rgba(0, 0, 0, 0.45)",
    minHeight: "100vh",
    padding: "20px",
    textAlign: "center",
    paddingBottom: "80px",
    color: "white",
  },

  title: {
    fontSize: "42px",
    fontWeight: "900",
    color: "#c8ffb3",
    marginBottom: "10px",
    textShadow: "0 0 10px rgba(0,255,120,0.4)",
  },

  subtitle: {
    fontSize: "20px",
    marginBottom: "30px",
    color: "#e1ffd8",
    width: "90%",
    maxWidth: "700px",
    marginLeft: "auto",
    marginRight: "auto",
  },

  downloadBtn: {
    display: "inline-block",
    marginTop: "10px",
    padding: "14px 28px",
    fontSize: "18px",
    fontWeight: "700",
    color: "#0b3d1b",
    background: "linear-gradient(135deg, #9cff8f, #4caf50)",
    borderRadius: "30px",
    textDecoration: "none",
    boxShadow: "0 6px 15px rgba(0,0,0,0.4)",
    transition: "all 0.25s ease",
  },

  downloadBtnHover: {
    transform: "translateY(-3px)",
    boxShadow: "0 10px 22px rgba(0,0,0,0.5)",
  },

  sliderWrapper: {
    width: "100%",
    overflow: "hidden",
    marginTop: "140px",
  },

  slider: {
    display: "flex",
    gap: "20px",
    width: "max-content",
    animation: "slideAnim 35s linear infinite",
  },

  card: {
    background: "rgba(46, 125, 50, 0.8)",
    borderRadius: "15px",
    padding: "18px",
    width: "260px",
    backdropFilter: "blur(6px)",
    border: "1px solid rgba(255,255,255,0.3)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
    transition: "0.3s",
  },

  cardTitle: {
    fontSize: "20px",
    fontWeight: "700",
    marginBottom: "8px",
    color: "#ffffff",
  },

  cardDesc: {
    fontSize: "15px",
    color: "#f1fff1",
  },
};

/* Keyframes */
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `
@keyframes slideAnim {
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0%); }
}
`,
  styleSheet.cssRules.length
);
